import React from "react";

import type { Props as ChipProps } from "@busbud/design-system-components/dist/Chip/Chip";
import Chip from "@busbud/design-system-components/dist/Chip/Chip";
import CheckSM from "@busbud/design-system-components/dist/Icons/Check/SM";
import CrossSM from "@busbud/design-system-components/dist/Icons/Cross/SM";

import { staticClsx } from "@app/components/tss/tss";

import { useStyles } from "./hepstar-terms-chip.styles";

export const COVERED = "covered";
export const COVERED_GREY = "covered_grey";
export const UNDER_CONDITIONS = "under_conditions";
export const NOT_COVERED = "not_covered";

type ChipCategory =
  | typeof COVERED
  | typeof COVERED_GREY
  | typeof UNDER_CONDITIONS
  | typeof NOT_COVERED;

interface Props {
  category: ChipCategory;
  label: React.ReactNode;
  with_start_icon?: boolean;
  className?: string;
}
const chips_props_by_category: Record<
  string,
  {
    startIcon: ChipProps["startIcon"];
    variant: ChipProps["variant"];
    color: ChipProps["color"];
  }
> = {
  [COVERED]: {
    startIcon: <CheckSM />,
    variant: "subtle",
    color: "green"
  },
  [COVERED_GREY]: {
    startIcon: <CheckSM />,
    variant: "subtle",
    color: "neutral"
  },
  [UNDER_CONDITIONS]: {
    startIcon: <CheckSM />,
    variant: "subtle",
    color: "yellow"
  },
  [NOT_COVERED]: {
    startIcon: <CrossSM />,
    variant: "subtle",
    color: "red"
  }
};

export const HepstarTermChip: React.FC<Props> = ({
  category,
  className,
  with_start_icon = true,
  label
}) => {
  const { classes } = useStyles();
  // @ts-expect-error TS2339 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const { startIcon, ...other } = chips_props_by_category[category];

  return (
    <div className={staticClsx(classes.wrapper, className)}>
      <Chip
        classes={{ label: classes.label, startIcon: classes.startIcon }}
        label={label}
        startIcon={with_start_icon ? startIcon : undefined}
        {...other}
      />
    </div>
  );
};
